<div
  class="bg-white rounded-xl p-2 flex justify-between items-start cursor-pointer hover:bg-gray-50 transition-colors duration-200"
  (click)="redirectToDetails()">
  <!-- IZQUIERDA: Info de la orden -->

  <div class="flex flex-col gap-1">
    <span class="text-metro-black">{{ dateOrder | date:'dd/MM/yyyy' }}</span>
    <span class="text-metro-blue text-xs">{{ displayLabel }}</span>
    <span class="text-metro-blue text-sm">{{ itemCount }} item{{ itemCount > 1 ? 's' : '' }}</span>

  </div>



  <div class="flex flex-col items-end gap-2">
    <span class="bg-gray-200 text-gray-700 text-xs px-2 py-1 rounded-xl whitespace-nowrap">
      {{ status | abpLocalization }}
    </span>

    <span class="text-metro-blue-secondary">
      ${{ totalPrice.toFixed(2) }}
    </span>

    <ng-content select="[action]"></ng-content>
  </div>
</div>